/**
 * PresenceIndicator - Shows what the other user is currently doing
 * 
 * Example: "Sarah is aan het plannen..."
 */

import React from 'react';
import { UserPresence, getActionLabel, getActionIcon } from '../../services/presenceService';

interface PresenceIndicatorProps {
  presence: UserPresence | null;
  className?: string;
}

const PresenceIndicator: React.FC<PresenceIndicatorProps> = ({ presence, className = '' }) => {
  if (!presence || presence.currentAction === 'idle') {
    return null;
  }
  
  const label = getActionLabel(presence.currentAction);
  const icon = getActionIcon(presence.currentAction);
  
  if (!label) {
    return null;
  }
  
  return (
    <div className={`flex items-center gap-2 px-3 py-2 bg-blue-50 border border-blue-200 rounded-lg text-sm ${className}`}>
      <div className="flex items-center gap-2 text-blue-700">
        <span className="text-lg animate-pulse">{icon}</span>
        <span className="font-medium">{presence.userName}</span>
        <span className="text-blue-600">{label}</span>
      </div>
      <div className="flex gap-1">
        <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
        <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
        <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
      </div>
    </div>
  );
};

export default PresenceIndicator;
